<template>
  <div class="page-container">
    <el-row>
      <el-col class="container-right">
        <div class="searchconditions">
          <el-form :model="listForm" ref="listForm" inline>
            <el-form-item prop="roleName" label="角色名称">
              <el-input v-model="listForm.roleName" placeholder="请输入角色名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" type="cyan" @click="handleSearch"
                >查询</el-button
              ><el-button
                icon="el-icon-refresh"
                type="warning"
                @click="resetForm"
                >重置</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <el-row :gutter="10" class="mb8">
          <el-col :span="1.5">
            <el-button
              class="add-button"
              type="primary"
              icon="el-icon-plus"
              size="mini"
              @click="handleAdd"
              >新增角色</el-button
            >
          </el-col>
        </el-row>
        <el-table :data="rolesList" style="width: 100%" v-loading="loading">
          <el-table-column
            prop="sortId"
            label="排序号"
            align="center"
          ></el-table-column>
          <el-table-column prop="roleName" label="角色名称" align="center">
          </el-table-column>
          <el-table-column prop="companyType" label="企业类型" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.companyType == 2">生产企业</span>
              <span v-if="scope.row.companyType == 4">塑业企业</span>
              <span v-if="scope.row.companyType == 8">终端门店</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1">正常</span>
              <span v-else-if="scope.row.status == 0">关闭</span>
              <!-- <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                :active-value="1"
                :inactive-value="0"
                @change="statusChange(scope.row)"
              ></el-switch> -->
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="center">
          </el-table-column>
          <el-table-column prop="createUser" label="最后操作人" align="center">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="最后操作时间"
            align="center"
            width="180"
          >
            <template slot-scope="scope">
              {{ scope.row.createTime | getDateFormat }}
            </template>
          </el-table-column>
          <el-table-column
            prop="age"
            label="操作"
            align="center"
            width="200"
            class="handle-btn"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="edit(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="success"
                size="mini"
                icon="el-icon-view"
                @click="sonList(scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next, sizes, total, jumper"
          :page-sizes="[10, 15, 20]"
          :page-size="pageSize"
          :total="total"
          :current-page="listForm.pageNum"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </el-col>
    </el-row>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="500px"
      @close="handleClose"
      
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="企业类型" prop="roleName">
          <el-select v-model="form.companyType">
            <el-option
              v-for="item in companyTypeList"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色名称" prop="roleName">
          <el-input
            v-model="form.roleName"
            placeholder="请输入角色名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序号" prop="sortId">
          <el-input v-model="form.sortId" placeholder="请输入排序号" maxlength="5" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="saveAddOrEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSystemRolesFatherCompanyList,
  saveSystemRoles,
  updateSystemRoles,
  updateRolesStatus,
  saveRolesNav,
} from "@/common/api.js";

export default {
  components: {},
  props: {},
  data() {
    return {
      pageSize: 10,
      currpage: 1,
      total: 0,
      dialogVisible: false,
      loading: false,
      // 拥有菜单id列表
      navIdList: [],
      roleId: null,
      roleName: "",

      searchShow: true,
      dialogDetails: false,
      rolesList: [],
      listForm: {
        companyName: "",
        status: "",
      },

      form: {
        roleName: "",
        roleType: "offical",
        companyType: null,
        sortId: null,
        remark: "",
      },
      // 弹出层标题
      title: "",
      //表单验证
      rules: {
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
        ],
        // sortId: [{ required: true, message: "请输入排序号", trigger: "blur" }],
      },
      //企业类型
      companyTypeList: [
        { id: 1, name: "生产企业" },
        { id: 2, name: "塑业企业" },
      ],
    };
  },
  watch: {},
  computed: {},
  methods: {
    //角色列表
    getSystemRolesList() {
      var params = {
        pageSize: this.pageSize,
        pagenum: this.currpage,
        data: {
          roleType: "offical",
          roleName: this.listForm.roleName,
        },
      };
      this.loading = true;
      getSystemRolesFatherCompanyList(params).then((res) => {
        console.log("res :>> ", res);
        this.loading = false;
        if (res.errorCode !== 200) {
          this.$message.error(res.msg);
        } else {
          this.rolesList = res.data.list || [];
          this.total = res.data.total || 0;
        }
      });
    },
    // 保存新增/编辑
    saveAddOrEdit() {
      console.log(this.form);
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.form.roleId) {
            updateSystemRoles(this.form).then((res) => {
              this.loading = false;
              if (res.errorCode == 200) {
                this.getSystemRolesList();
                this.dialogVisible = false;
                this.$message({
                  type: "success",
                  message: "保存成功",
                });
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            saveSystemRoles(this.form).then((res) => {
              this.loading = false;
              if (res.errorCode == 200) {
                this.getSystemRolesList();
                this.dialogVisible = false;
                this.$message({
                  type: "success",
                  message: "保存成功",
                });
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        }
      });
    },

    //选页
    handleCurrentChange(cpage) {
      this.currpage = cpage;
      this.getSystemRolesList();
    },
    handleSizeChange(psize) {
      this.pageSize = psize;
      this.getSystemRolesList();
    },

    // 新增角色
    handleAdd() {
      this.reset();
      this.dialogVisible = true;
      this.title = "新增角色";
    },
    // 编辑角色
    edit(row) {
      this.reset();
      this.dialogVisible = true;
      this.title = "编辑角色";
      console.log(row);
      this.form = {
        roleName: row.roleName,
        roleType: "offical",
        companyType: row.companyType,
        sortId: row.sortId,
        remark: row.remark,
        roleId: row.roleId,
      };
      console.log(this.form.roleName);
    },
    //修改角色状态
    statusChange(row) {
      console.log(row);
      var department = row.roleName;
      let text = "";
      if (row.status == 1) {
        text = "有效";
      } else if (row.status == 0) {
        text = "失效";
      }
      const h = this.$createElement;
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h(
            "h3",
            null,
            '是否将 "' + department + '" 的状态变为 "' + text + '" ?',
            "警告"
          ),
        ]),
        showCancelButton: true,
        closeOnClickModal:false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            done();
            var params = {
              roleId: row.roleId,
              status: row.status,
            };
            updateRolesStatus(params).then((res) => {
              if (res.errorCode == 200) {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
              } else {
                this.$message.error(res.msg);
                if (row.status == 1) {
                  row.status = 0;
                } else if (row.status == 0) {
                  row.status = 1;
                }
              }
            });
          } else {
            done();
            if (row.status == 1) {
              row.status = 0;
            } else if (row.status == 0) {
              row.status = 1;
            }
            console.log(row.status);
          }
        },
      })
        .then((action) => {
          console.log("确定");
        })
        .catch(() => {
          console.log("取消");
        });
    },
    // 查看子集列表
    sonList(row) {
      console.log(row);
      this.$router.push({
        path: "/admin/home/companyUserSonPage",
        query: {
          id: row.roleId,
          name: row.roleName,
          companyType: row.companyType,
        },
      });
    },
    // 表单重置
    reset() {
      this.form = {
        roleName: "",
        roleType: "offical",
        sortId: null,
        remark: "",
      };
    },
    //弹框关闭 重置form
    handleClose() {
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    },
    // 查询
    handleSearch() {
      this.listForm.pageNum=1;
      this.getSystemRolesList();
    },
    resetForm() {
      this.$nextTick(() => {
        this.$refs["listForm"].resetFields();
        this.getSystemRolesList();
      });
    },
    close() {
      this.dialogVisible = false;
    },
  },
  created() {},
  mounted() {
    this.getSystemRolesList();
  },
};
</script>
<style lang="less" scoped>
.page-container {
  height: 100%;
  .el-row {
    height: 100%;
  }
  .container-right {
    padding: 5px 10px 12px;
    border-radius: 6px;
    background-color: #fff;
    margin-top: 10px;
    .add-button {
      margin: 20px 0 10px 10px;
    }
    .searchconditions {
      background: #fff;
      border-radius: 6px;
      margin-top: 10px;
      padding: 5px 15px 12px;
      box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
      .el-form {
        .el-form-item {
          display: inline-block;
          margin-right: 10px;
          vertical-align: top;
          margin: 5px 15px 5px 0px;
          /deep/.el-button {
            padding: 8px 15px;
            font-size: 12px;
            border-radius: 3px;
          }
        }
      }
    }
  }
  .el-row {
    // margin: 10px 0 0 !important ;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    // padding: 5px 15px 0;
    .add-btn {
      float: left;
      padding: 0;
      margin-top: 5px;
      margin-bottom: 10px;
      .el-button {
        padding: 8px 15px;
        font-size: 12px;
        border-radius: 3px;
      }
    }
    .btn-group-right {
      float: right;
      .el-button {
        padding: 8px;
      }
    }
    .btn-group-right {
      margin-top: 5px;
      span {
        display: inline-block;
        vertical-align: top;
        font-size: 20px;
        padding: 8px;
      }
    }
  }
  /deep/.el-input__inner,
  /deep/.el-form-item__content {
    height: 34px;
    line-height: 34px;
  }
  /deep/.el-input__icon,
  /deep/.el-form-item__label {
    line-height: 34px;
  }
  .tree-list {
    font-size: 14px;
    .tree-status {
      font-size: 12px;
      background-color: #f0f0f0;
      padding: 2px 3px;
      color: red;
    }
  }
  .roleInfo {
    text-align: center;
    padding-bottom: 20px;
    font-size: 16px;
    color: #333;
    font-weight: 600;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/system/rolesManage/companyUserPage.vue